import { render, staticRenderFns } from "./relContractView02.vue?vue&type=template&id=4115986a"
import script from "./relContractView02.vue?vue&type=script&lang=js"
export * from "./relContractView02.vue?vue&type=script&lang=js"
import style0 from "./relContractView02.vue?vue&type=style&index=0&id=4115986a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports